import { useTranslation } from 'react-i18next';

import { useProductCenterApi } from 'api';
import { getUrlServiceProtocolFileDownload } from 'api/ApiUrls';
import { ProtocolFileDto } from 'api/v1/data-contracts';
import { PrintableAttachmentsSection } from 'modules/Shared/PdfPrint/PrintableAttachmentsSection';

interface PrintableAttachmentsProps {
	attachments: ProtocolFileDto[];
}

export const PrintableAttachments = ({
	attachments,
}: PrintableAttachmentsProps) => {
	const { t } = useTranslation(['serviceProtocol']);
	const { api } = useProductCenterApi();

	return (
		<PrintableAttachmentsSection
			attachments={attachments}
			sectionTitle={t(
				'serviceProtocol:protocolPrintout-additionalFilesToPrint'
			)}
			printFailedMessage={t(
				'serviceProtocol:protocolPrintout-print-failed'
			)}
			getFileUrl={(attachment) =>
				getUrlServiceProtocolFileDownload(attachment.id)
			}
			onDownload={async (attachment) =>
				(
					await api.downloadServiceProtocolFile(attachment.id, {
						format: 'blob',
					})
				).data as unknown as Blob
			}
		/>
	);
};
